export default "__VITE_ASSET__75bce132__"